import Viewer from "@/react/story/components/viewers/Viewer";
import { useItems } from "@/react/story/providers/ItemsContext";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";

export default function ViewerStory() {
    const Items = useItems();

    const route = Items.current;
    if (!route) {
        return null;
    }

    return (
        <div id="story-viewer-page" style={{
            // Autour d'une story plus petite que l'écran : noir par défaut, comme sur les
            // réseaux sociaux, plutôt qu'une couleur étrangère à la marque.
            backgroundColor: "#000000",
            ...TemplatingUtils.style(route.page.config, null, [ "backdropFilter" ]),
        }}>
            <div id="story-viewer-page-inner" style={{
                ...TemplatingUtils.style(route.page.config, [ "backdropFilter" ]),
            }}>
                <Viewer />
            </div>
        </div>
    );
}
